import Vue from 'vue'
import App from './App.vue'
import store  from './store'
import './main.css'
import AOS from 'aos'
import 'aos/dist/aos.css'
import moment from 'moment'
import VueGtag from "vue-gtag"

Vue.use(VueGtag, {
  config: { id: "UA-61923158-18" }
});

Vue.prototype.moment = moment
Vue.config.productionTip = false

new Vue({
  store,
  render: h => h(App),
    mounted() {
        AOS.init({ offset: 10, anchorPlacement: 'top-center',})
    },
}).$mount('#wellness-navigator')